import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/layout/Header/Header";
import Footer from "./components/layout/Footer/Footer";
import ScrollToTop from "./components/common/ScrollToTop/ScrollToTop";
import WhatsAppButton from "./components/common/WhatsAppButton/WhatsAppButton";
import Home from "./pages/Home";
import ProductsPage from "./pages/ProductsPage";
import Admin from "./pages/Admin";
import "./styles/globals.css";

function App() {
  return (
    <LanguageProvider>
        <Router>
          <div className="App">
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </main>
            <Footer />
            <ScrollToTop />
            <WhatsAppButton />
          </div>
        </Router>
    </LanguageProvider>
  );
}

export default App;
